import Stack from 'threads5/Stack';

export default Stack;
